import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, hasMany, options } from '@apexdesigner/schema-tools';

export const salePhoto = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    hipNumber: z.string().describe('Catalog hip number, e.g. "0989".'),

    sex: options([
      { value: 'C', name: 'Colt' },
      { value: 'F', name: 'Filly' },
      { value: 'G', name: 'Gelding' },
      { value: 'R', name: 'Ridgling' },
    ])
      .nullable()
      .optional()
      .describe('Sex of the horse, from the banner code.'),

    sire: z
      .string()
      .nullable()
      .optional()
      .describe('Sire (father), e.g. "Quality Road".'),

    dam: z
      .string()
      .nullable()
      .optional()
      .describe('Dam (mother), e.g. "Spritz".'),

    consignor: z
      .string()
      .nullable()
      .optional()
      .describe('Consignor and agent, e.g. "Darby Dan Farm, Agent IX".'),

    imageData: z
      .string()
      .nullable()
      .optional()
      .hidden()
      .describe(
        'Base64-encoded image bytes. Column type to be set when upload is built.',
      ),

    contentType: z
      .string()
      .nullable()
      .optional()
      .disabled()
      .describe('MIME type of the image, e.g. "image/jpeg".'),

    imageWidth: z
      .number()
      .nullable()
      .optional()
      .disabled()
      .describe('Image width in pixels.'),

    imageHeight: z
      .number()
      .nullable()
      .optional()
      .disabled()
      .describe('Image height in pixels.'),

    saleId: z.number().hidden().describe('Foreign key to Sale'),

    sale: belongsTo('Sale'),

    measurementSets: hasMany('MeasurementSet'),
  })
  .describe(
    'A sale-catalog photograph of one cataloged horse. Carries the listing\nidentity read from the banner — hip number, sex, sire, dam, consignor —\nalong with the image and its pixel dimensions. Belongs to a sale and is\nmeasured in one or more measurement sets.',
  )
  .as('SalePhoto');

export { salePhoto as salePhotoSchema };
